<div class="modal-header">
    <h5 class="modal-title">Default Entity Assignment Fields</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<dirty-tracking [forms]="[defaultForm]"></dirty-tracking>
<form novalidate #defaultForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body" *ngIf="vendorInfo">
        <div class="row gx-3">
            <div class="col-md mb-3 mb-md-0">
                <label class="form-label d-block">Audited</label>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="defaultsAudited" id="defaultsAuditedTrue" [value]="true" [(ngModel)]="vendorInfo.defIsAudited">
                    <label class="form-check-label" for="defaultsAuditedTrue">True</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="defaultsAudited" id="defaultsAuditedFalse" [value]="false" [(ngModel)]="vendorInfo.defIsAudited">
                    <label class="form-check-label" for="defaultsAuditedFalse">False</label>
                </div>
            </div>
            <div class="col-md mb-3 md-md-0">
                <label for=" vendorformularyLock" class="form-label d-block">Allow ordering under min?</label>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="defaultsOrderMin" id="defaultsOrderMinTrue" [value]="true" [(ngModel)]="vendorInfo.defAllowOrderUnderMinimum">
                    <label class="form-check-label" for="defaultsOrderMinTrue">True</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="defaultsOrderMin" id="defaultsOrderMinFalse" [value]="false" [(ngModel)]="vendorInfo.defAllowOrderUnderMinimum">
                    <label class="form-check-label" for="defaultsOrderMinFalse">False</label>
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md mb-3">
                <label for="vendorMinAmount" class="form-label">Minimum Order Amount</label>
                <div class="input-group">
                    <span class="input-group-text"><i class="far fa-dollar-sign"></i></span>
                    <input type="number" step="0.01" class="form-control form-control-lg" id="vendorMinAmount" name="vendorMinAmount" placeholder="Minimum Order" [(ngModel)]="vendorInfo.defMinOrderAmount">
                </div>
            </div>
            <div class="col-md mb-3">
                <label for="vendorMinPenalty" class="form-label">Minimum Order Penalty</label>
                <div class="input-group">
                    <span class="input-group-text"><i class="far fa-dollar-sign"></i></span>
                    <input type="number" step="0.01" class="form-control form-control-lg" id="vendorMinPenalty" name="vendorMinPenalty" placeholder="Minimum Penalty" [(ngModel)]="vendorInfo.defMinOrderPenalty">
                </div>
            </div>
            <div class="col-md mb-3">
                <label for="vendorMinPenalty" class="form-label">Additional Fees</label>
                <div class="input-group">
                    <span class="input-group-text"><i class="far fa-dollar-sign"></i></span>
                    <input type="number" step="0.01" class="form-control form-control-lg" id="vendorAddlFees" name="vendorAddlFees" placeholder="Additional Fees" [(ngModel)]="vendorInfo.defAdditionalFees">
                </div>
            </div>
        </div>
        <hr />
        <div class="accordion" id="masterAccordion">
            <div class="row gx-3">
                <div class="col-md-auto mb-3">
                    <div class="row align-items-end gx-3">
                        <div class="col-md-auto mb-3 mb-md-0">
                            <label for=" vendorformularyLock" class="form-label d-block">Formulary Lock?</label>
                            <div class="btn-group btn-group-lg" role="group">
                                <button type="button" class="btn btn-outline-black" [ngClass]="{'active': vendorInfo.defFormularyLock}" (click)="vendorInfo.defFormularyLock = true; markDirty();">Yes</button>
                                <button type="button" class="btn btn-outline-black" [ngClass]="{'active': !vendorInfo.defFormularyLock}" (click)="vendorInfo.defFormularyLock = false; markDirty();">No</button>
                            </div>
                        </div>
                        <div class="col-md-auto">
                            <label for="vendorMaster" class="form-label d-block">Master</label>
                            <div class="btn-group btn-group-lg" role="group">
                                <button type="button" role="button" [ngClass]="{'active': vendorInfo.defMasterFileInherit}" (click)="vendorInfo.defMasterFileInherit = true; markDirty();" aria-expanded="false" aria-controls="masterInherit" class="btn btn-outline-black">Inherit</button>
                                <button type="button" role="button" [ngClass]="{'active': !vendorInfo.defMasterFileInherit}" (click)="vendorInfo.defMasterFileInherit = false; markDirty();" aria-expanded="false" aria-controls="masterChoose" class="btn btn-outline-black">Choose</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md mb-3" *ngIf="!vendorInfo.defMasterFileInherit">
                    <!-- choose -->
                    <div class="" id="masterChoose">
                        <label for="vendorMaster" class="form-label">Master</label>
                        <input id="choose-master-input" class="mobi-input form-control form-control-lg mb-3" placeholder="Select Master" name="choose-master-input" required mbsc-select [data]="vendorInfo.masterFiles" [(ngModel)]="vendorInfo.defMasterFileId" [mbscOptions]="masterFileOptions" />
                        <div class="invalid-feedback">
                            <i class="fas fa-exclamation-circle"></i> This field is required.
                        </div>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="makeMasterFormulary" name="makeMasterFormulary" [(ngModel)]="vendorInfo.defMasterIsFormulary">
                        <label class="form-check-label" for="makeMasterFormulary">
                            Make this master my formulary
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="save()"><i class="far fa-check"></i>
            Set Defaults</button>
    </div>
</form>